/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui';



/* ++++++++++ --------------- MONETIZATION CHARTCARDS : STYLES --------------- ++++++++++ */
export default {
    chartcards: {
        display: 'flex',
        width: '100%',
        flexWrap: 'wrap',
        '& .chartcard': {
            flex: '1',
            marginBottom: pxToEm(16),
            marginRight: pxToEm(16),
            '&:last-child': {
                marginRight: 0
            }
        }
    },
    // ((((((((((((((( MEDIA QUERIES ))))))))))))))) //
    [`@media only screen and (max-width:${pxToEm(1300)})`]: {
        chartcards: {
            '& .chartcard': {
                width: '100%',
                flex: 'initial',
                marginRight: 0
            }
        }
    },
    // ((((((((((((((( MEDIA QUERIES ))))))))))))))) //
    [`@media only screen and (min-width:${pxToEm(1301)}) and (max-width:${pxToEm(1480)})`]: {
        chartcards: {
            justifyContent: 'space-between',
            '&.sidebar-open': {
                '& .chartcard': {
                    width: '48%',
                    flex: 'initial',
                    marginRight: 0
                }
            }
        }
    }
};
